import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const MetaTags = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const [metaData, setMetaData] = useState<any>({});
  const [previousTitle, setPreviousTitle] = useState<string>('');
  const language = i18n.language === 'fr' ? 'fr' : 'en';

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/meta/translations/${language}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch ${language}.json`);
        }
        return response.json();
      })
      .then((data) => setMetaData(data))
      .catch((error) => {
        console.error('Error loading meta data:', error);
        setMetaData({});
      });
  }, [language]);

  const pathParts = location.pathname
    .toLowerCase()
    .replace(/\/$/, '')
    .replaceAll('-', '')
    .split('/')
    .filter(part => part); // Remove empty segments

  // Find all matching keys by checking combinations of path segments
  const matchingKeys = Object.keys(metaData).filter((key) => {
    // Try matching from the end of the path, combining 1-3 segments
    for (let i = 1; i <= Math.min(3, pathParts.length); i++) {
      const combinedKey = pathParts.slice(-i).join('');
      if (key === combinedKey) {
        return true;
      }
    }
    return false;
  });

  // Select the longest matching key (most specific match)
  const matchedKey: any = matchingKeys.reduce((longest, current) => {
    return current.length > longest.length ? current : longest;
  }, '');

  const currentMeta = metaData[matchedKey] || {
    ogTitle: 'Air Canada NDC',
    ogDescription:
      'Air Canada is unlocking new value for travel sellers thanks to its new distribution capabilities bringing a modern shopping experience.',
    ogImage: '/preview-meta1.png',
    ogUrl: location.pathname,
    ogType: 'website',
    ogImageAlt: 'Air Canada Logo'
  };

  // Announce title changes
  useEffect(() => {
    if (previousTitle && previousTitle !== currentMeta.ogTitle) {
      // Small delay to ensure the title is announced after page navigation
      const announcer = document.getElementById('title-announcer');

      setTimeout(() => {
        if (announcer) {
          announcer.textContent = `${currentMeta.ogTitle}`;
        }
      }, 100);

      // setTimeout(() => {
      //   if (announcer && announcer.parentNode) {
      //     announcer.parentNode.removeChild(announcer);
      //   }
      // }, 3000);
    }
    setPreviousTitle(currentMeta.ogTitle);
  }, [currentMeta.ogTitle, previousTitle]);

  return (
    <>
      <Helmet htmlAttributes={{ lang: language }}>
        <title>{currentMeta.ogTitle}</title>
        <meta name="description" content={currentMeta.ogDescription} />
        <meta property="og:title" content={currentMeta.ogTitle} />
        <meta property="og:description" content={currentMeta.ogDescription} />
        <meta property="og:image" content={currentMeta.ogImage} />
        <meta property="og:url" content={currentMeta.ogUrl} />
        <meta property="og:type" content={currentMeta.ogType} />
        <meta property="og:image:alt" content={currentMeta.ogImageAlt} />
      </Helmet>
      {/* Screen reader announcement */}
      <div
        id="title-announcer"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      />
    </>
  );
};

export default MetaTags;
